import Swal from "sweetalert2";
import { RemoteConstants } from "../../../data/remote/RemoteConstants";
import { UIActions } from "../../../presentation/redux/actions/UIActions";
import { errorManager } from "../../../presentation/utils/errorManager";
import { handleLogout } from "../../../presentation/utils/handleLogout";

export const emailValidation = (email, token) => async (dispatch) => {
  try {
    dispatch(UIActions.uiLoadActive());

    const params = new URLSearchParams({
      token: token,
      email: email
    });
    const response = await fetch(`${RemoteConstants.BASE_URL}pos/email/validation?${params.toString()}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });

    const data = await response.json();

    if (data.code === 'OK') {
      Swal.fire({
        title: "¡Hecho!",
        text: data.userMessage,
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          handleLogout();
        }
      })
    } else {
      Swal.fire({
        title: "Error",
        text: data.userMessage,
        icon: 'error',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          handleLogout();
        }
      });
    }
  } catch (error) {
    errorManager(error)
  }
  dispatch(UIActions.uiLoadInactive());
}